import React from "react";
import { Question } from "@/features/Surveys/Question";
import { CloseIcon } from "@/assets/icons";
import { SurveyResponseType } from "@/types/surveys";
import { FlexRow, FlexColumn } from "../FlexContainer/FlexContainer";
import Typography from "../Typography/Typography";
import Modal from "./Modal";
import cls from "./styles.module.scss";

interface ChatSurveyModalProps {
  isOpen: boolean;
  onCancel: () => void;
  img: string | undefined;
  survey_response: SurveyResponseType;
}

export const ChatSurveyModal = ({
  isOpen,
  onCancel,
  img,
  survey_response,
}: ChatSurveyModalProps) => {
  const answers = survey_response.answers.filter(
    (elem) =>
      elem.text !== "WITHOUT_RESPONSE" &&
      elem.text !== null &&
      elem.text !== "" &&
      elem.text !== undefined &&
      elem.text !== "TRUE" &&
      elem.text !== "FALSE"
  );
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      manageFocus
      ariaLabel={survey_response.survey.title}
      overlayCls={cls.chatSurveyOverlay}
      modalCls={cls.surveyModalWrapper}
      contentCls={cls.surveyModalContent}
    >
      <FlexColumn gap={16} className={cls.surveyHeader}>
        <FlexRow justifyContent="space-between">
          <FlexRow gap={8}>
            <img src={img} alt={img} />
            <Typography
              family="Manrope"
              weight="medium"
              size="2xl"
              lineHeight="32px"
              color="var(--text-dark-secondary)"
            >
              {survey_response.survey.title}
            </Typography>
          </FlexRow>

          <button
            type="button"
            aria-label="Закрыть анкету"
            className={cls.surveyCloseButton}
            onClick={onCancel}
          >
            <CloseIcon />
          </button>
        </FlexRow>

        {/* <FlexRow gap={24} className={cls.petsInfo}>
          <div className={cls.avatar}>
            <img
              src={
                survey_response.pet.image || "/images/collage_placeholder.png"
              }
              alt=""
            />
          </div>
          <FlexColumn gap={8}>
            <Typography
              family="Manrope"
              weight="bold"
              size="4xl"
              lineHeight="46px"
              color="var(--text-brown)"
            >
              {survey_response.pet.name}
            </Typography>
            <Typography
              size="md"
              lineHeight="24px"
              color="var(--text-dark-secondary)"
            >
              {survey_response.pet.age} лет {survey_response.pet.breed}
            </Typography>
            <Typography size="md" lineHeight="24px" color="#000">
              {survey_response.pet.description}
            </Typography>
          </FlexColumn>
        </FlexRow> */}
      </FlexColumn>
      <FlexColumn gap={24} className={cls.surveyBody}>
        {answers.map((elem, index) => (
          <Question
            key={index}
            question={elem.question_text}
            number={index + 1}
            quantity={answers.length}
            textareaValue={elem.text}
            textareaOnChange={() => false}
            inChat={true}
          />
        ))}
      </FlexColumn>
    </Modal>
  );
};
